// utils.js
import { createTheme } from '@mui/material/styles';

export const getMuiTheme = () =>
    createTheme({
        components: {
            MuiTableCell: {
                styleOverrides: {
                    head: {
                        background: 'linear-gradient(to right, #cceaff, #e0f7ff)', // light sky blue gradient
                        color: '#003366', // deep blue text for good contrast
                        fontWeight: 'bold',
                        fontSize: '14px',
                        textAlign: 'center',
                        paddingTop: '2px',    // add vertical spacing
                        paddingBottom: '2px', // to simulate row height
                        textTransform: 'uppercase',
                        borderBottom: '2px solid #b3dfff', // subtle border matching tone
                    },
                    body: {
                        fontSize: '13px',
                        height: 18, // Adjust td height
                        verticalAlign: 'middle',
                        paddingTop: '2px',    // add vertical spacing
                        paddingBottom: '2px', // to simulate row height
                        textAlign: 'center', // Optional: Center table data
                    },
                },
            },
            MuiTableRow: {
                styleOverrides: {
                    root: {
                        height: 40,
                        transition: 'background-color 0.3s ease-in-out',
                        '&:hover': {
                            backgroundColor: '#f0faff',
                            cursor: 'pointer',
                        },
                    },
                },
            },
        },
    });


export const openInNewWindow = (url) => {
    window.open(url, "_blank", "height=600,width=1200,top=100,left=100");
};